
















































































import 'reflect-metadata'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'

@Component({
    components: { Tooltip },
})
export default class EVMLogRow extends Vue {
    @Prop() log!: any

    decodedLog: any = null

    @Watch('abisLoaded')
    async onAbisLoadedChanged() {
        const isDecoded = this.$store.state.abiDecoder.decodeLogs([this.log])
        if (isDecoded !== [undefined]) {
            this.decodedLog = isDecoded[0]
        }
    }

    get abisLoaded() {
        return this.$store.state.abisLoaded
    }
}
